var $ = require('jquery');
var URI = require('URIjs');
var _ = require('underscore');

function Tracker(appId, cleanUrl = true) {
    if (!window.ga || !appId) {
        return;
    }

    var uri = new URI();
    var query = uri.search(true);
    var clientId = query.cid;

    if (clientId) {
        window.history.replaceState({}, document.title, uri.removeSearch('cid').toString());
        ga('create', appId, 'auto', {
            clientId: clientId,
        });
    } else {
        ga('create', appId, 'auto');
    }

    window.ga('require', 'ec', 'ec.js');
    window.ga('set', 'forceSSL', true);
    window.ga('set', 'anonymizeIp', true);

    this._customDimensions = {
        dimension1: 'visitor', // role
        dimension2: 'undefined', // current hiveId context
        dimension3: 'undefined', // userId
        dimension4: 'undefined', // distributionId
        dimension5: 'undefined', // ActiveFeatures
    };

    this.setCampaignParameters(cleanUrl);
}

Tracker.prototype.setCampaignParameters = function(cleanUrl = true) {
    // We need to remove the campain parameters so that the router starts with a 'clean' URL
    var uri = new URI();

    if (uri.search().indexOf('utm') > -1) { // The URL contains 'utm', the Google Analytics query parameters prefix
        var query = uri.search(true);
        _.each(query, function(value, key) {
            if (key.indexOf('utm') === 0) {
                switch (key) {
                case 'utm_campaign':
                    window.ga('set', 'campaignName', value);
                    break;
                case 'utm_medium':
                    window.ga('set', 'campaignMedium', value);
                    break;
                case 'utm_source':
                    window.ga('set', 'campaignSource', value);
                    break;
                case 'utm_content':
                    window.ga('set', 'campaignContent', value);
                    break;
                }
                delete query[key];
            }
        });

        if (cleanUrl) {
            if (!!(window.history && history.pushState)) {
                window.history.replaceState({}, document.title, uri.search(query).toString());
            } else {
                document.location = uri.search(query).toString();
            }
        }
    }
};

Tracker.prototype.sendPageView = function() {
    var uri = new URI();
    var language = uri.segment(0);
    var page = uri.segment(0, '').path().substr(1);

    window.ga('send', 'pageview', {
        'page': page,
        'language': language,
        'dimension1': this._customDimensions.dimension1,
        'dimension2': this._customDimensions.dimension2,
        'dimension3': this._customDimensions.dimension3,
        'dimension4': this._customDimensions.dimension4,
        'dimension5': this._customDimensions.dimension5,
    });
};

Tracker.prototype.sendEvent = function(category, action, label, value) {
    return window.ga('send', 'event', category, action, label, value, this._customDimensions);
};

Tracker.prototype.trackConversion = function() {
    window.google_conversion_id = 951656385;
    window.google_conversion_language = 'en';
    window.google_conversion_format = '3';
    window.google_conversion_color = 'ffffff';
    window.google_conversion_label = 'w6S8CNaNhVwQwb_kxQM';
    window.google_remarketing_only = false;
    $.getScript('https://www.googleadservices.com/pagead/conversion.js');
    $('body').append('<img height="1" width="1" style="border-style:none; position: absolute; left: -9999px;" alt="" src="https://www.googleadservices.com/pagead/conversion/951656385/?label=w6S8CNaNhVwQwb_kxQM&amp;guid=ON&amp;script=0"/>');
};

Tracker.prototype.updateRole = function(role) {
    this._customDimensions.dimension1 = role;
};

Tracker.prototype.clearRole = function() {
    this._customDimensions.dimension1 = 'visitor';
    this._customDimensions.dimension2 = 'undefined';
    this._customDimensions.dimension3 = 'undefined';
    this._customDimensions.dimension4 = 'undefined';
    this._customDimensions.dimension5 = 'undefined';
};

Tracker.prototype.updateUserId = function(id) {
    this._customDimensions.dimension3 = id + '' || 'undefined';
};

Tracker.prototype.updateAssemblyId = function(context) {
    this._customDimensions.dimension2 = context.get('data') && context.get('data').hiveId+'' || 'undefined';
};

Tracker.prototype.registerFeature = function(featureName) {
    if (this._customDimensions.dimension5 === 'undefined') {
        this._customDimensions.dimension5 = featureName;
    } else {
        this._customDimensions.dimension5 += (' ' + featureName);
    }
};

Tracker.prototype.eCommerceImpression = function(data) {
    this._customDimensions.dimension4 = data.distributionId+'',
    window.ga('ec:addProduct', {
        id: 1,
        name: 'name',
    });
    window.ga('ec:setAction', 'detail');
    this.sendEvent('Ecommerce', 'impression');
};

Tracker.prototype.eCommerceProductAdded = function(data) {
    this._customDimensions.dimension4 = data.distributionId+'',
    window.ga('set', '&cu', data.currency);
    window.ga('ec:addProduct', {
        id: data.id,
        name: data.name,
        price: parseInt(data.price) / 100,
        quantity: data.quantity,
        variant: data.variant,
    });
    window.ga('ec:setAction', 'add');
    this.sendEvent('Ecommerce', 'add');
};

Tracker.prototype.eCommerceCheckout = function(data) {
    this._customDimensions.dimension4 = data.distributionId+'',
    window.ga('ec:setAction', 'checkout');
    this.sendEvent('Ecommerce', 'checkout');
};

Tracker.prototype.eCommercePayment = function(data) {
    this._customDimensions.dimension4 = data.distributionId+'',
    window.ga('set', '&cu', data.currency);
    window.ga('ec:setAction', 'purchase', {
        id: data.id,
        revenue: parseInt(data.revenue) / 100,
    });
    this.sendEvent('Ecommerce', 'transaction');
};

Tracker.prototype.eCommerceCategoryFilter = function() {
    this.sendEvent('Ecommerce', 'categoryfilter');
};

Tracker.prototype.eCommerceSubCategoryFilter = function() {
    this.sendEvent('Ecommerce', 'subcategoryfilter');
};

Tracker.prototype.eCommerceOrganicFilter = function() {
    this.sendEvent('Ecommerce', 'organicfilter');
};

Tracker.prototype.eCommerceAlreadyBoughtFilter = function() {
    this.sendEvent('Ecommerce', 'alreadyboughtfilter');
};

Tracker.prototype.eCommerceProductExpand = function() {
    this.sendEvent('Ecommerce', 'expandproduct');
};

Tracker.prototype.eCommerceFarmExpand = function() {
    this.sendEvent('Ecommerce', 'expandfarm');
};

Tracker.prototype.showJoinAssemblyForm = function(assemblyId) {
    this.sendEvent('Register', 'showjoinform', assemblyId);
};

Tracker.prototype.submitJoinAssemblyForm = function(assemblyId) {
    if (assemblyId === 3819) {
        this.trackConversion();
    }
    this.sendEvent('Register', 'submitjoinform', assemblyId);
};

Tracker.prototype.downloadFinancialDocument = function(documentType) {
    this.sendEvent('Professionals', 'downloadfinancialdocument', documentType);
};

Tracker.prototype.downloadProducerOrders = function(type) {
    this.sendEvent('Producers', 'downloadOrder', type);
};

[
    {category: 'Tutorial', action: 'viewedAllTutorial'},
    {category: 'Tutorial', action: 'closedAtIntroTutorial'},
    {category: 'Tutorial', action: 'closedAtStepsTutorial'},
    {category: 'Tutorial', action: 'viewLaterTutorial'},
].forEach(function(options) {
    Tracker.prototype[options.action] = function(tutorialLabel) {
        this.sendEvent(options.category, options.action, tutorialLabel);
    }
});

module.exports = Tracker;
